<template>
    <section class="ifr__section ifr__section--intro">
        <div class="intro__header">
            <div class="-ui-container">
                <div class="-ui-grid">
                    <div>
                        <header class="intro__stamp">
                            <h6>{{ $t('intro.h6') }}</h6>
                            <h1 v-html="$t('intro.h1')"></h1>
                            <ul>
                                <li>{{ $t('intro.hastags.letstalk') }}</li>
                                <li>{{ $t('intro.hastags.dementia') }}</li>
                            </ul>
                        </header>
                        <ul class="intro__ssmm">
                            <li class="ifr__warnings-ssmm--fb">
                                <a href="https://www.facebook.com/sharer/sharer.php?u=http://www.paho.org/lets-talk-about-dementia/" target="_blank">
                                    <svg width="50px" height="90px" viewBox="0 0 50 90" >
                                        <path d="M50,15.6465 L35.717,15.6465 C34.029,15.6465 32.143,17.8675 32.143,20.8385 L32.143,31.1535 L50,31.1535 L50,45.8535 L32.143,45.8535 L32.143,90.0005 L15.285,90.0005 L15.285,45.8535 L0,45.8535 L0,31.1535 L15.285,31.1535 L15.285,22.5005 C15.285,10.0925 23.896,0.0005 35.717,0.0005 L50,0.0005 L50,15.6465 Z" id="Fill-1"></path>
                                    </svg>
                                </a>
                            </li>
                            <li class="ifr__warnings-ssmm--tw">
                                <a href="https://twitter.com/intent/tweet?url=http://www.paho.org/lets-talk-about-dementia/" target="_blank">
                                    <svg width="92px" height="15px" viewBox="0 0 92 75">
                                        <path d="M92,8.8497 C88.613,10.3517 84.977,11.3657 81.158,11.8227 C85.057,9.4867 88.049,5.7867 89.459,1.3797 C85.811,3.5417 81.771,5.1137 77.473,5.9597 C74.029,2.2907 69.123,-0.0003 63.695,-0.0003 C53.271,-0.0003 44.82,8.4507 44.82,18.8737 C44.82,20.3537 44.986,21.7937 45.309,23.1747 C29.623,22.3887 15.711,14.8737 6.404,3.4537 C4.779,6.2427 3.848,9.4847 3.848,12.9437 C3.848,19.4917 7.18,25.2677 12.244,28.6537 C9.152,28.5557 6.24,27.7077 3.695,26.2937 C3.693,26.3717 3.693,26.4507 3.693,26.5307 C3.693,35.6757 10.201,43.3047 18.834,45.0377 C17.252,45.4697 15.584,45.7017 13.861,45.7017 C12.646,45.7017 11.465,45.5827 10.311,45.3627 C12.713,52.8607 19.686,58.3187 27.943,58.4697 C21.482,63.5337 13.346,66.5507 4.502,66.5507 C2.979,66.5507 1.477,66.4607 0,66.2847 C8.352,71.6417 18.271,74.7677 28.934,74.7677 C63.65,74.7677 82.637,46.0047 82.637,21.0617 C82.637,20.2457 82.619,19.4307 82.582,18.6197 C86.27,15.9597 89.469,12.6357 92,8.8497" id="Fill-1"></path>
                                    </svg>
                                </a>
                            </li>
                            <li class="ifr__warnings-ssmm--adi">
                                <a href="http://www.alz.co.uk/" target="_blank">
                                    <img src="../assets/img/adilogo.jpeg" alt="">
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="intro__ctas">
            <div class="-ui-container">
                <ul>
                    <li>
                        <a class="ifr__btn" :href="$t('intro.ctas.campaign.url')" target="_blank">
                            <span>{{ $t('intro.ctas.campaign.title') }}</span>
                            <span>{{ $t('intro.ctas.campaign.title') }}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'intro'
}
</script>

